<div class="flex flex-column align-items-center justify-content-center h-full">
    <iframe 
        (load)="onLoad()" 
        class="w-full h-full"
        [ngClass]="{
            'opacity-0': !showIframe(),
            'max-h-0': !showIframe()
        }" 
        [src]="loginUrl" 
        frameborder="0"
    ></iframe>
    @if (!showIframe()) {
        <medsurf-design-content-process-spinner />
    }
</div>